/*
 * @Author: your name
 * @Date: 2022-03-31 10:37:04
 * @LastEditTime: 2022-07-01 10:39:26
 * @LastEditors: James chen
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\config\planManage.js
 */
//计划管理
export const planManageMap = [
  {
    path: '/workshopPlanList',
    name: 'carRoomList',
    component: () => import('@/views/planManage/carRoomPlaneList'),
    meta: { title: '车间计划', keepAlive: false }
  },
  {
    path: '/carRoomPlaneDetail',
    name: 'carRoomPlaneDetail',
    component: () => import('@/views/planManage/carRoomPlaneDetail'),
    meta: { title: '计划详情', keepAlive: false }
  },
  {
    path: '/carRoomPlaneSearch',
    name: 'carRoomPlaneSearch',
    component: () => import('@/views/planManage/search'),
    meta: { title: '更多筛选', keepAlive: false }
  },
  {
    path: '/productOrder',
    name: 'productOrder',
    component: () => import('@/views/productOrder/index'),
    meta: { title: '生产订单', keepAlive: false }
  },
  {
    path: '/approval',
    name: 'approval',
    component: () => import('@/views/approval/approval'),
    meta: { title: '审批', keepAlive: false }

  },
  {
    path: '/waiterApply',
    name: 'waiterApply',
    component: () => import('@/views/dashboard/waiterApply'),
    meta: { title: '待处理申请列表', keepAlive: false },
  },
  {
    path: '/otherApply',
    name: 'otherApply',
    component: () => import('@/views/dashboard/otherApply'),
    meta: { title: '其他三种申请', keepAlive: false },
  },
  {
    path: '/commonSearch',
    name: 'commonSearch',
    component: () => import('@/views/common/search'),
    meta: { title: '筛选', keepAlive: false }
  },
  // {     
  //   path: '/recordDetail',
  //   name: 'recordDetail',
  //   component: () => import('@/views/reportRecord/recordDetail'),
  //   meta: { title: ' 生产报工', keepAlive: false }
  //  },
  {
    path: '/recordDetail1',
    name: 'recordDetail1',
    component: () => import('@/views/reportRecord/recordDetail1'),
    meta: { title: '发货申请', keepAlive: false }
  },
  {
    path: '/recordDetail2',
    name: 'recordDetail2',
    component: () => import('@/views/reportRecord/recordDetail2'),
    meta: { title: '采购详情', keepAlive: false }
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/views/apply/apply'),
    meta: { title: '发起申请', keepAlive: false }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/reportRecord/test'),
    meta: { title: '发起申请', keepAlive: false }
  },
  {
    path: '/apply/applyDeliver',
    name: 'applyDeliver',
    component: () => import('@/views/apply/applyDeliver'),
    meta: { title: '申请发货', keepAlive: false }
  },
  {
    path: '/apply/applyDeliverDetail',
    name: 'applyDeliverDetail',
    component: () => import('@/views/apply/applyDeliverDetail'),
    meta: { title: '申请发货', keepAlive: false }
  },
  {
    path: '/apply/applyPay',
    name: 'applyPay',
    component: () => import('@/views/apply/applyPay'),
    meta: { title: '申请采购', keepAlive: false }
  },
  {
    path: '/apply/applyPayDetail',
    name: 'applyPayDetail',
    component: () => import('@/views/apply/applyPayDetail'),
    meta: { title: '采购详情', keepAlive: false }
  },
  {
    path: '/apply/qualityDetail',
    name: 'qualityDetail',
    component: () => import('@/views/apply/qualityDetail'),
    meta: { title: '质检报工详情', keepAlive: false }
  },
  {
    path: '/qualityDetail',
    name: 'qualityDetail',
    component: () => import('@/views/apply/qualityDetail'),
    meta: { title: '质检报工详情', keepAlive: false }
  },
  {
    path: '/recordDetail',
    name: 'recordDetail',
    component: () => import('@/views/apply/recordDetail'),
    meta: { title: '生产报工', keepAlive: false }
  },
  {
    path: '/salesManagement/salesContractDetail',
    name: 'salesContractDetail',
    component: () => import('@/views/apply/salesContractDetail'),
    meta: { title: '销售合同详情', keepAlive: false }
  },
  {
    path: '/salesManagement/salesInvoiceDetail',
    name: 'salesInvoiceDetail',
    component: () => import('@/views/apply/salesInvoiceDetail'),
    meta: { title: '销售收款开票详情', keepAlive: false }
  },
  {
    path: '/procurementManagement/purchaseDetail',
    name: 'purchaseDetail',
    component: () => import('@/views/apply/purchaseDetail'),
    meta: { title: '采购合同详情', keepAlive: false }
  },
  {
    path: '/procurementManagement/purchasePaymentDetail',
    name: 'purchasePaymentDetail',
    component: () => import('@/views/apply/purchasePaymentDetail'),
    meta: { title: '采购付款详情', keepAlive: false }
  },
  {
    path: '/procurementManagement/supplierDetail',
    name: 'supplierDetail',
    component: () => import('@/views/apply/supplierDetail'),
    meta: { title: '供应商详情', keepAlive: false }
  },
  {
    path: '/procurementManagement/receiptDetail',
    name: 'receiptDetail',
    component: () => import('@/views/apply/receiptDetail'),
    meta: { title: '采购合同签收详情', keepAlive: false }
  },
  {
    path: '/workManagement/materialRequisitionDetail',
    name: 'materialRequisitionDetail',
    component: () => import('@/views/workManagement/materialRequisition/materialRequisitionDetail'),
    meta: { title: '领料详情', keepAlive: false }
  },
  {
    path: '/workManagement/addMaterialRequisitionDetail',
    name: 'addMaterialRequisitionDetail',
    component: () => import('@/views/workManagement/addMaterialRequisition/addMaterialRequisitionDetail'),
    meta: { title: '补料详情', keepAlive: false }
  },
  {
    path: '/workManagement/qualifiedInput/qualifiedInputDetail',
    name: 'qualifiedInputDetail',
    component: () => import('@/views/workManagement/qualifiedInput/qualifiedInputDetail'),
    meta: { title: '合格品入库详情', keepAlive: false }
  },
  {
    path: '/workManagement/executionDetail',
    name: 'executionDetail',
    component: () => import('@/views/workManagement/defectsDeal/executionDetail'),
    meta: { title: '报废入库详情', keepAlive: false }
  },
  {
    path: '/workManagement/executionDetail',
    name: 'executionDetail',
    component: () => import('@/views/workManagement/defectsDeal/executionDetail'),
    meta: { title: '报废入库详情', keepAlive: false }
  },
  {
    path: '/workManagement/returnMaterial/returnMaterialDetail',
    name: 'returnMaterialDetail',
    component: () => import('@/views/workManagement/returnMaterial/returnMaterialDetail'),
    meta: { title: '申请退料详情', keepAlive: false }
  },
]
